import React, { useState, useEffect } from "react";
import Styles from "../../../components/Styles";
import Copyrights from "../../../components/Copyrights";
import Footer from "../../../components/Footer";
import { useTranslation } from "react-i18next";
import HotelBanner from "../../../components/hotel/Banner";
import Header from "../../../components/Header";
import HotelSearchResults from "./Results";
import { useLocation } from "react-router-dom";
import FilterAndMap from "../../../components/hotel/FilterAndMap";

const HotelSearch = () => {
  const translationContext = useTranslation();
  const location = useLocation();
  const route = location.pathname;
  const query = new URLSearchParams(window.location.search);
  
  // State to track if it's mobile or desktop
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  // Effect to handle window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const searchParams = {
    adults: Number(query.get("adults")) || 2,
    children: Number(query.get("children")) || 0,
    checkInDate: query.get("checkInDate") || "",
    checkOutDate: query.get("checkOutDate") || "",
    currency: query.get("currency") || "EUR",
    cityId: query.get("cityId") || "",
    nationality: query.get("nationality") || "XK",
    city: query.get("city") || "",
    apiCityName: query.get("apiCityName") || query.get("city") || "",
    cityLat: query.get("cityLat"),
    cityLng: query.get("cityLng"),
  };


  return (
    <div style={{ 
      backgroundColor: "white",
      position: 'relative',
      overflow: 'visible',
      minHeight: '100vh'
    }}> 
      <Styles />
      {!isMobile && (
        <Header
          translation={translationContext.t}
          translationContext={translationContext}
        />
      )}
      <div style={{ position: 'relative', zIndex: 2 }}>
        <HotelBanner translation={translationContext.t} translationContext={translationContext} />
      </div>
      {route === "/hotels/search" && <HotelSearchResults searchParams={searchParams} translation={translationContext.t} />}
      <Footer />
      <Copyrights />
    </div>
  );
};

export default HotelSearch;
